<template>
  <div class="results">
    <Banner
      :title="'RESULTS'"
      :class-banner="'common-banner'"
    />
    <div class="results__winners">
      <div class="results__winners-title">{{this.listTimes[this.activeIndex]['time']}}</div>
      <div class="results__winners-content">Rs 1,000,000.00</div>
      <div class="results__winners-des">Winning Numbers</div>
      <ul class="results__winners-items">

        <li v-for="(ball, index) in this.listTimes[this.activeIndex]['result']"
            :key ="index"
            class="results__winners-item ball">{{ball}}</li>
      </ul>

    </div>
    <div class="results__days">
      <div
        v-for="(item, index) in listTimes"
        :key="index"
        class="results__days-item ball"
        :class="{active : item.isActive}"
        @click="handleActiveItem(index)"
      >
        {{ item.time }}
      </div>
    </div>
    <div class="results__information">
      <div class="results__information-title">PRIZES</div>
    </div>
    <Table
      :fields="fields"
      :items="items"
      :is-pagination="false"
      :custom-class-container="'table-results-custom'"
    />
  </div>
</template>

<script>
import Banner from '@/components/common/banner';
import Table from '@/components/common/table/table';
export default {
  components: {
    Table,
    Banner
  },
  data() {
    return {
      activeIndex: 0,
      listTimes: [
        {
          time: 'Friday 05 Nov 2021',
          result: [3, 7, 11, 16, 19, 26, 28],
          isActive: true
        },
        {
          time: 'Friday 29 Oct 2021',
          result: [1, 5, 12, 18, 21, 25, 27],
          isActive: false
        },
        {
          time: 'Friday 22 Oct 2021',
          result: [7, 8, 13, 15, 18, 21, 23],
          isActive: false
        },
        {
          time: 'Friday 15 Oct 2021',
          result: [1, 5, 14, 10, 22, 23, 26],
          isActive: false
        },
        {
          time: 'Friday 08 Oct 2021',
          result: [7, 13, 19, 20, 24, 25, 28],
          isActive: false
        },
        {
          time: 'Friday 01 Oct 2021',
          result: [2, 3, 7, 15, 21, 22, 25],
          isActive: false
        }
      ],
      fields: [
        {key: 'matched', label: 'Matched'},
        {key: 'totalWinners', label: 'Total Winners'},
        {key: 'totalPrizes', label: 'Prizes'}
      ],
      items: [
        {matched: 'Match 7 numbers', totalWinners: 0, totalPrizes: 'Rs 1,000,000.00'},
        {matched: 'Match 6 numbers', totalWinners: 0, totalPrizes: 'Rs 500,000.00'},
        {matched: 'Match 5 numbers', totalWinners: 0, totalPrizes: 'Rs 200,000.00'},
        {matched: 'Match 4 numbers', totalWinners: 0, totalPrizes: 'Rs 73,000.00'},
        {matched: 'Match 3 numbers', totalWinners: 0, totalPrizes: 'Rs 3,000.00'},
        {matched: 'Match 2 numbers', totalWinners: 0, totalPrizes: 'Rs 1,000.00'},
        {matched: 'Match 1 numbers', totalWinners: 0, totalPrizes: 'Rs 500.00'},
      ]
    }
  },
  methods: {
    handleActiveItem(index) {
      this.listTimes.forEach((item, i) => {
        item.isActive = i === index;
        this.activeIndex = index;
      });

      console.log('testing', index);
      console.log('index', this.activeIndex);
      console.log("???", this.listTimes[1]);
    }
  }
}
</script>
